import { render, staticRenderFns } from "./top-color.vue?vue&type=template&id=3749b4ea"
import script from "./top-color.vue?vue&type=script&lang=js"
export * from "./top-color.vue?vue&type=script&lang=js"
import style0 from "./top-color.vue?vue&type=style&index=0&id=3749b4ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports